import React from 'react';
import { useEventsList } from './useEventsList';
import { EventsList } from './EventsList';

export const Events = () => {
  const data = useEventsList();
  return <EventsList data={data} />;
}
